class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.addEventListener('touchstart', (event) => {
      if (!event.touches || event.touches.length !== 1) return;
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
    }, { passive: true });
    this.addEventListener('touchend', (event) => {
      if (!this.touchStartX || !event.changedTouches || !event.changedTouches.length) return;
      const deltaX = event.changedTouches[0].clientX - this.touchStartX;
      const deltaY = event.changedTouches[0].clientY - this.touchStartY;
      this.touchStartX = 0;
      this.touchStartY = 0;
      if (deltaX > 64 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) this.close();
    }, { passive: true });
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    
    this.swipeSurface = this.querySelector('.drawer__inner');
    this.pointerStartX = 0;
    this.pointerStartY = 0;
    if (this.swipeSurface) {
      this.swipeSurface.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch') return;
        this.pointerStartX = event.clientX;
        this.pointerStartY = event.clientY;
        if (this.swipeSurface.setPointerCapture) this.swipeSurface.setPointerCapture(event.pointerId);
      }, { passive: true });
      this.swipeSurface.addEventListener('pointerup', (event) => {
        if (event.pointerType !== 'touch' || !this.pointerStartX) return;
        const deltaX = event.clientX - this.pointerStartX;
        const deltaY = event.clientY - this.pointerStartY;
        this.pointerStartX = 0;
        this.pointerStartY = 0;
        if (this.swipeSurface.releasePointerCapture && this.swipeSurface.hasPointerCapture(event.pointerId)) {
          this.swipeSurface.releasePointerCapture(event.pointerId);
        }
        if (deltaX > 44 && Math.abs(deltaX) > Math.abs(deltaY) * 1.1) this.close();
      }, { passive: true });
      this.swipeSurface.addEventListener('pointercancel', () => {
        this.pointerStartX = 0;
        this.pointerStartY = 0;
      }, { passive: true });
      this.swipeSurface.addEventListener('touchstart', (event) => {
        if (!event.touches || event.touches.length !== 1) return;
        this.touchFallbackStartX = event.touches[0].clientX;
        this.touchFallbackStartY = event.touches[0].clientY;
      }, { passive: true });
      this.swipeSurface.addEventListener('touchend', (event) => {
        if (!this.touchFallbackStartX || !event.changedTouches || !event.changedTouches.length) return;
        const deltaX = event.changedTouches[0].clientX - this.touchFallbackStartX;
        const deltaY = event.changedTouches[0].clientY - this.touchFallbackStartY;
        this.touchFallbackStartX = 0;
        this.touchFallbackStartY = 0;
        if (deltaX > 44 && Math.abs(deltaX) > Math.abs(deltaY) * 1.1) this.close();
      }, { passive: true });
    }

    this.addEventListener('click', (event) => {
      const drawerShell = this.querySelector('#CartDrawer');
      const drawerInner = this.querySelector('.drawer__inner');
      if (drawerShell && drawerInner && event.target === drawerShell) this.close();
    });
    // shs-925-cart-outside-close

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
